import clsx from 'clsx'
import {useMemo} from 'react'
import {useBreakpoint} from '../../../components/hooks/useBreakpoint'

interface BannerImageProps {
  className?: string
  marginTop?: string
  imageBanner?: string
}
export const BannerImage = ({className, marginTop, imageBanner}: BannerImageProps) => {
  const {down} = useBreakpoint()
  const image = useMemo(() => {
    if (imageBanner) return imageBanner
    return '/media/saas/admm-banner.jpg'
  }, [imageBanner])
  const isiPad = useMemo(() => {
    return down('md')
  }, [down])
  return (
    <div
      className={clsx('mb-5', className)}
      style={{
        marginTop: marginTop ? marginTop : isiPad ? '-15px' : '-30px',
        marginLeft: isiPad ? '-15px' : '-30px',
        marginRight: isiPad ? '-15px' : '-30px',
      }}
    >
      <img width='100%' src={image} alt='banner' />
    </div>
  )
}
